module.exports = __webpack_public_path__ + "img/photo1508262441726879676.9f55bcf3.jpg";